import React from 'react';
import { useTranslation } from 'react-i18next';

export function LanguageSelector() {
    const {i18n } = useTranslation();

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLanguage = event.target.value;
        i18n.changeLanguage(selectedLanguage);
    };
    return (
        <div className="languageSelectorDropdown">
            <select
                value={i18n.language}
                onChange={handleChange}
                className="languageSelect"
            >
                <option value="es">🇪🇸 Castellano</option>
                <option value="va">🇻🇦 Valencià</option>
            </select>
        </div>
    );
}